<template>
    <!-- <div>
        <div id="serial_header_wrapper"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div class="serial-header-col">
                <div id="serial_campaign_img">
                    <img :src="campaign.fullImageUrl" />
                </div>
            </div>
            <div id="serial_campaign_info" class="serial-header-col">
                <div id="serial_agencyname">{{campaign.agencyName}}</div>
                <div id="serial_campaign">{{campaign.name}}</div>
            </div>
        </div>
    </div> -->
    <div>
        <div class="serial-header"
            :class="[{'serial-header--mass': theme == 'mass'}, {'serial-header--prestige': theme == 'prestige'}]">
            <div class="serial-header__campaign-img">
                <img :src="campaign.fullImageUrl" />
            </div>
            <div class="serial-header__campaign-info">
                <div class="serial-header__agency-name">{{campaign.agencyName}}</div>
                <div class="serial-header__campaign-name">{{campaign.name}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SerialHeader',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        campaign: Object
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
.serial-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;

    .serial-header__campaign-img {
        width: 115px;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        @include baseRatioImg(75%);
    }

    .serial-header__campaign-info {
        flex: 1;
    }

    .serial-header__agency-name {
        font-size: 12px;
        font-weight: 400;
        color: $color-gray;
    }

    .serial-header__campaign-name {
        font-size: 16px;
        font-weight: 600;
        color: $color-gray;
        @extend %ellipsis-3;
    }
}
</style>
